<lib-dialog
  [title]="
    'lib_calendar.appointment-confirmation-dialog.text.title' | translate
  "
  [isLoading]="isLoading"
  [displayActionContainerAsColumnOnMobile]="true"
  (closeButtonClick)="closeDialog()"
>
  <div body>
    <lib-calendar-appointment-details
      [mode]="mode"
      [businessObject]="businessObject"
      [appointment]="appointment"
      [staff]="appointment?.staff"
    ></lib-calendar-appointment-details>
  </div>

  <ng-container action>
    <button mat-stroked-button [disabled]="isLoading" (click)="closeDialog()">
      {{
        'lib_calendar.appointment-confirmation-dialog.buttons.cancel'
          | translate
      }}
    </button>

    <button
      mat-flat-button
      color="primary"
      [disabled]="isLoading"
      (click)="submit()"
    >
      {{
        (appointment?.id
          ? 'lib_calendar.appointment-confirmation-dialog.buttons.confirm-and-update'
          : 'lib_calendar.appointment-confirmation-dialog.buttons.confirm-and-book'
        ) | translate
      }}
    </button>
  </ng-container>
</lib-dialog>
